import React from 'react';
import { AlertCircleIcon, CheckCircle2Icon, LockIcon } from 'lucide-react';
interface StatusBannerProps {
  tone: 'error' | 'success' | 'locked';
  children: React.ReactNode;
}
const toneStyles = {
  error: 'border-red-200 bg-red-50 text-red-700',
  success: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  locked: 'border-slate-200 bg-slate-100 text-slate-700'
};
export function StatusBanner({
  tone,
  children
}: StatusBannerProps) {
  const Icon = tone === 'error' ? AlertCircleIcon : tone === 'success' ? CheckCircle2Icon : LockIcon;
  return <p role={tone === 'error' ? 'alert' : 'status'} className={`flex items-start gap-2.5 rounded-lg border px-4 py-3 text-sm font-semibold ${toneStyles[tone]}`} data-id="element-512" data-mp="2oxpsn9fu6w23">
      <Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-513" data-mp="2f14mgks2zewo" />
      <span data-id="element-514" data-mp="18mdfq0ga0zuq">{children}</span>
    </p>;
}